import { IApplicationState } from '../../../../types/types';
import { getAuthUser } from './getAuthUser';

export const isTrialUser = (
    state: IApplicationState
): boolean => {
    return Boolean(getAuthUser(state).activeSubscription.find(subscription => subscription.isTrial))
};
